import { Box, chakra, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Container = ({ children, className }: Props) => {
  const bgGradient = useColorModeValue(
    'linear(to-b, #FAFCFD 0%, #ffffff 100%)',
    'linear(to-b, black 0%, gray.900 100%)',
  );

  return (
    <Box
      className={ className }
      minWidth={{ base: '100vw', lg: 'fit-content' }}
      m="0 auto"
      bgGradient={ bgGradient }
      minH="100vh"
    >
      { children }
    </Box>
  );
};

export default React.memo(chakra(Container));
